<main cdkTrapFocus>
  <h1 mat-dialog-title id="modal-title" class="mat-headline-1">{{this.parentComponent?.addButton?.label}} {{data.label
    ?? dialogFields[0]?.props?.label}}</h1>
  <mat-dialog-content class="mutara-dialog-content">
    @if ( isDetail ) {
    <table>
      @for (field of dialogFields; track field.key ;let i = $index ) {
      <tr>
        @if ( !isButton(field)) {
        <td>{{field.props?.label}}</td>
        <td>{{field.formControl?.value}}</td>
        } @else {
        <td colspan=2>
          <button mat-flat-button type='button'
            [disabled]="dialogGroup.formControl?.invalid || parentField.props?.disabled" [title]='field.props?.label'
            (click)='parentComponent.performButtonAction($event,null,null,0)'
            color="'primary'">{{field.props?.description ?? field.props?.label}}</button>
        </td>
        }
      </tr>
      }
    </table>
    } @else {
    <section class="display-flex">
      <formly-form [form]="form" [model]="model" [fields]="dialogFields" [options]="options">
      </formly-form>
    </section>
    <mat-dialog-actions align='end'>
      <button mat-flat-button type='button' mat-dialog-close color='accent'>Cancel</button>
      @if ( parentComponent.props?.hideReset ) {
      <button mat-flat-button type='button' [disabled]="!parentField.props?.capForm.isEditable" (click)="resetForm()"
        color='accent'>Reset</button>
      }
      @if (parentComponent._selectedRow != -1 && !!this.parentComponent.deleteButton?.visible) {
      <button mat-flat-button type='button' [disabled]="!parentField.props?.capForm.isEditable"
        (click)="updateData('delete')" color='accent'>{{this.parentComponent.deleteButton.label}}</button>
      }
      <button mat-flat-button type='button'
        [disabled]="dialogGroup.formControl?.invalid || !parentField.props?.capForm?.isEditable"
        (click)="updateData(parentComponent?.addButton?.label == 'Update' ? 'update' : 'insert')"
        color='accent'><mat-icon>{{parentComponent?.addButton?.icon}}</mat-icon>{{this.parentComponent?.addButton?.label}}</button>
    </mat-dialog-actions>
    }
  </mat-dialog-content>
</main>